import type { Feature } from '@luna/gatekeeper';

export const cardCancellationWarning: Feature = {
    enabled: true,
};
